import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=880a2b86&"
import script from "./Modelos.vue?vue&type=script&lang=ts&"
export * from "./Modelos.vue?vue&type=script&lang=ts&"
import style0 from "./Modelos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports